import IconComponent from "@mdi/react";
import { FunctionComponent } from "react";

import { mdiContentCopy } from "@mdi/js";

import { useUser } from "hooks";

import { IColumns } from "models/columns";
import { EntityKind } from "models/entityKind";

import CopyButton from "./CopyButton";
import MonthlyDisabledButton from "./MonthlyDisabledButton";
import useMonthlyProduction from "./hooks/useMonthlyProduction";

// Copies the page on screen as TSV, headers first, through the Data view's copy button.
// Values are copied as returned, at full precision, not as the grid rounds them.
const MonthlyCopyButton: FunctionComponent = () => {
  const { hasTrialAccount, isReadonly } = useUser();
  const { data } = useMonthlyProduction();

  // Trial and read-only accounts get the Data view's copy button, which hides itself.
  if (!data?.rows.length && !hasTrialAccount && !isReadonly) {
    return (
      <MonthlyDisabledButton
        label="Copy Data Table"
        reason="No monthly production to copy."
        reasonId="monthly-copy-disabled-reason">
        <IconComponent path={mdiContentCopy} size={1.2} />
      </MonthlyDisabledButton>
    );
  }

  return (
    <CopyButton
      rows={(data?.rows ?? []) as Record<string, string>[]}
      columns={(data?.columns ?? []) as IColumns[]}
      selectedProperties={[]}
      entityKind={EntityKind.Well}
      view="monthly-production"
    />
  );
};

export default MonthlyCopyButton;
